import React from 'react';
import {Col, Input, Row} from "reactstrap";
import TextLabel from "../../../../../Controls/TextLabel.mjs";

const AvvisiEditorBody = class extends React.Component {
	constructor(props) {
		super(props);
		const m = props.message || {};
		this.state = {
			message: m,
			value: m.body || ''
		};
		this.onChange = this.onChange.bind(this);
	}
	onChange = (v) => {
		const m = this.props.getter();
		m.body = v;
		m.text = true;
		this.setState( { value: v, message: m }, ()=>{
			this.props.setter( m );
		});
	};
	render() {
		return(
			<Row>
				<Col>
					<TextLabel value={"Message"} />
				</Col>
				<Col>
					<Input
						value={ this.state.value }
						onChange={e => { this.onChange( e.target.value ); }}
						type="textarea"
						rows={6}
					/>
				</Col>
			</Row>
		)
	}
};

export default AvvisiEditorBody;
